import { render, staticRenderFns } from "./IngresosCactualPage.vue?vue&type=template&id=5d2b791c"
import script from "./IngresosCactualPage.js?vue&type=script&lang=js&external"
export * from "./IngresosCactualPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports